import { useEffect, useState } from "react";
import { X, Trash2 } from "lucide-react";

export default function EditBalanceModal({ program, onClose, onSave, onDelete }) {
  const [balance, setBalance] = useState(program.balance ?? 0);
  const [tier, setTier] = useState(program.tier || "");
  const [holder, setHolder] = useState(program.holder || "self");
  const [notes, setNotes] = useState(program.notes || "");

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 fade-in"
      style={{ background: "rgba(10,10,10,0.45)" }}
      onClick={onClose}
      data-testid="edit-balance-modal"
    >
      <div
        className="card w-full max-w-md p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          aria-label="Close"
          className="absolute top-3 right-3 text-neutral-400 hover:text-black"
          onClick={onClose}
          data-testid="edit-balance-close"
        >
          <X size={18} />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div
            className="w-10 h-10 rounded-[10px] flex items-center justify-center text-white font-bold text-[13px] shrink-0 overflow-hidden"
            style={{ background: program.color || "#1f2937" }}
          >
            {program.logo ? (
              <img
                src={program.logo}
                alt=""
                className="w-full h-full object-contain bg-white"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            ) : (
              program.name.charAt(0)
            )}
          </div>
          <div>
            <div className="font-display font-bold tracking-tight">{program.name}</div>
            <div className="text-[12px] text-neutral-500">Edit balance & details</div>
          </div>
        </div>

        <div className="space-y-3">
          <label className="block">
            <div className="label mb-1">Balance ({program.currency || "pts"})</div>
            <input
              type="number"
              className="input tabular"
              value={balance}
              onChange={(e) => setBalance(Number(e.target.value))}
              data-testid="edit-balance-input"
              autoFocus
            />
          </label>
          <label className="block">
            <div className="label mb-1">Status / tier</div>
            <input className="input" value={tier} onChange={(e) => setTier(e.target.value)} />
          </label>
          <label className="block">
            <div className="label mb-1">Holder / nickname</div>
            <input className="input" value={holder} onChange={(e) => setHolder(e.target.value)} />
          </label>
          <label className="block">
            <div className="label mb-1">Notes</div>
            <textarea className="input" rows="2" value={notes} onChange={(e) => setNotes(e.target.value)} />
          </label>
        </div>

        <div className="flex items-center justify-between mt-5 pt-4 border-t border-black/5">
          <button
            onClick={() => {
              if (window.confirm(`Remove ${program.name} from your dashboard?`)) onDelete(program.id);
            }}
            className="btn btn-ghost text-[13px] text-red-700"
            data-testid="edit-balance-delete"
          >
            <Trash2 size={14} /> Remove
          </button>
          <div className="flex gap-2">
            <button onClick={onClose} className="btn btn-ghost text-[13px]">Cancel</button>
            <button
              data-testid="edit-balance-save"
              className="btn btn-primary text-[13px]"
              onClick={() =>
                onSave(program.id, {
                  balance: Number(balance),
                  tier,
                  holder,
                  notes,
                  freshness: "manual",
                })
              }
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
